<script setup>
import { computed } from 'vue'
import { useMainStore } from '../stores/main-store'
import CurrentFilterButton from './CurrentFilterButton.vue'

const mainStore = useMainStore()

function findAttBySlugInTerms(tax, slug, name) {
  const data = mainStore.apiData[name]
  const att = data.find((curData) => curData.slug === tax)
  return att.terms.find((curAtt) => curAtt.slug === slug)
}

const filters = computed(() => {
  const filters = {
    cats: [],
    atts: [],
  }

  const cats = mainStore.selectedCategories
  if (Object.keys(cats).length) {
    for (const attTax in cats) {
      const attVals = cats[attTax]

      if (Object.keys(attVals).length) {
        for (const attSlug in attVals) {
          const attSlugVal = attVals[attSlug]

          if (attSlugVal === true) {
            filters.cats.push(findAttBySlugInTerms(attTax, attSlug, 'cats'))
          }
        }
      }
    }
  }

  const atts = mainStore.selectedAttributes
  if (Object.keys(atts).length) {
    for (const attTax in atts) {
      const attVals = atts[attTax]

      if (Object.keys(attVals).length) {
        for (const attSlug in attVals) {
          const attSlugVal = attVals[attSlug]

          if (attSlugVal === true) {
            filters.atts.push(findAttBySlugInTerms(attTax, attSlug, 'atts'))
          }
        }
      }
    }
  }

  return filters
})
</script>

<template>
  <div v-auto-animate class="filter-buttons">
    <button
      v-if="mainStore.filterQuery"
      class="filter-button"
      type="button"
      @click="mainStore.filterQuery = ''"
    >
      "{{ mainStore.filterQuery }}"
    </button>
    <CurrentFilterButton
      v-for="filter in filters.cats"
      :key="filter.slug"
      :attribute="filter"
      name="selectedCategories"
    />
    <CurrentFilterButton
      v-for="filter in filters.atts"
      :key="filter.slug"
      :attribute="filter"
      name="selectedAttributes"
    />
  </div>
</template>

<style lang="scss">
@import '../scss/current-filters';
</style>
